import { render, staticRenderFns } from "./MidwifeSignOffDetail.vue?vue&type=template&id=ca98c8f4"
import script from "./MidwifeSignOffDetail.vue?vue&type=script&lang=js"
export * from "./MidwifeSignOffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports